'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useState } from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import CardRecipeGrid from 'components/cards/CardRecipeGrid';
import ButtonCTA from 'components/ui/ButtonCTA';
import ShowMore from 'components/ui/ShowMore';
import Text from 'components/ui/Text';

import ResultHeader from '../ResultHeader';
import skeletonStyles from '../Skeleton/Skeleton.module.scss';

import styles from './RecipeResults.module.scss';

const itemsPerGroup = 12;

const RecipeResults = ({ items, isLoading = false }) => {
    const recipes = items.filter(item => typeof item?.sys?.id === 'string');
    const isNoResults = recipes.length === 0;

    const [visibleGroups, setVisibleGroups] = useState(1);

    const visibleItems = visibleGroups * itemsPerGroup;
    const allItemsVisible = visibleGroups * itemsPerGroup >= recipes.length;

    const remainingItems = Math.max(0, recipes.length - visibleItems);

    const handleMoreClick = () => {
        if (visibleItems < recipes.length) {
            setVisibleGroups(visibleGroups + 1);
        }
    };

    return (
        <section className={styles.root}>
            <ResultHeader
                type="Recipes"
                number={recipes.length}
                isLoading={isLoading}
                countLabel="saved"
            />
            {isLoading ? (
                <ul className={skeletonStyles.list}>
                    {new Array(4).fill(null).map((_, index) => (
                        <li className={skeletonStyles.listItem} key={index}>
                            <div className={skeletonStyles.skeletonCard}>
                                <div
                                    className={skeletonStyles.skeletonCardImage}
                                />
                                <div
                                    className={skeletonStyles.skeletonCardText}
                                >
                                    <span
                                        className={
                                            skeletonStyles.skeletonCardEyebrow
                                        }
                                    >
                                        <span
                                            className={skeletonStyles.textFill}
                                        >
                                            placeholder
                                        </span>
                                    </span>
                                    <span
                                        className={
                                            skeletonStyles.skeletonCardHeadline
                                        }
                                    >
                                        <span
                                            className={skeletonStyles.textFill}
                                        >
                                            Loading recipe title
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : isNoResults ? (
                <ul className={styles.inner}>
                    <li className={styles.listItem}>
                        <div className={styles.zeroState}>
                            <div className={styles.zeroStateInner}>
                                <Text
                                    baseTheme="headingXSmall"
                                    themes={{ medium: 'headingSmall' }}
                                    className={styles.zeroStateText}
                                    as="p"
                                >
                                    Browse recipes to find inspiration you can
                                    bookmark for your next craving, dinner, or
                                    party.
                                </Text>
                                <ButtonCTA
                                    link={{ slug: 'recipes' }}
                                    style="filled-blue-ocean"
                                    className={styles.cta}
                                    text="View Recipes"
                                />
                            </div>
                        </div>
                    </li>
                </ul>
            ) : (
                <>
                    <ul className={styles.inner}>
                        {recipes.map((recipe, index) => {
                            return (
                                <li
                                    className={cx(styles.listItem, {
                                        [styles.show]: index < visibleItems,
                                    })}
                                    key={recipe?.sys?.id || recipe?.id || index}
                                >
                                    <CardRecipeGrid
                                        id={recipe?.sys?.id || recipe?.id}
                                        image={recipe.image}
                                        images={recipe.images}
                                        category={recipe.category}
                                        cookTime={recipe.cookTime}
                                        prepTime={recipe.prepTime}
                                        slug={recipe.slug}
                                        title={recipe.title}
                                        attributes={recipe.attributes}
                                        mealTypeLabels={recipe.mealTypeLabels}
                                    />
                                </li>
                            );
                        })}
                        <li
                            key="end-card"
                            className={cx(styles.listItem, {
                                [styles['listItem--no-results']]: isNoResults,
                            })}
                        >
                            <div
                                className={
                                    styles['listItem--no-results-filler']
                                }
                            ></div>
                        </li>
                    </ul>
                    {!allItemsVisible && (
                        <div className={styles.showMoreContainer}>
                            <ShowMore
                                onClick={handleMoreClick}
                                remainingItems={remainingItems}
                            />
                        </div>
                    )}
                </>
            )}
        </section>
    );
};

RecipeResults.propTypes = {
    items: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
};

export default RecipeResults;
